import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  bondNumber: [],
  bondType: [],
  bondSubCategory: [],
  principal: [],
  estate: [],
  lawFirm: [],
  attorney: [],
  internalUser: [],
  status: [],
  startDate: null,
  endDate: null,
};

const initialState = {
  page: 0,
  filters: initialFilters,
};

const pgBondsSlice = createSlice({
  name: "pgBonds",
  initialState,
  reducers: {
    setPgBondsPage: (state, action) => {
      state.page = action.payload;
    },
    setPgBondsFilters: (state, action) => {
      state.filters = action.payload || initialFilters;
    },
    resetPgBondsState: (state) => {
      state.page = 0;
      state.filters = initialFilters;
    },
  },
});

export const { setPgBondsPage, setPgBondsFilters, resetPgBondsState } = pgBondsSlice.actions;
export default pgBondsSlice.reducer;

